import React, { memo } from 'react';
import { Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { View, Text } from '../../../Base';
import BaseCard from './BaseCard';
import palette from '../../../styles/palette';
import StatsInfoRows from './StatsInfoRows';
import { COLLECTIONS, PARCELS } from '../../../../constants/strings';

const useStyles = makeStyles(() => ({
  text: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: palette.typography.white.high,
  },
  container: {
    marginTop: '0.313rem',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  bold: {
    fontWeight: 'bold',
  },
  grey: {
    color: palette.typography.white.medium,
  },
  valueMargin: {
    marginLeft: '0.313rem',
  },
  titleLeftMargin: {
    marginLeft: '2.063rem',
  },
  divider: {
    height: '0.063rem',
    background: palette.typography.white.neutral,
    marginBottom: '0.313rem',
    marginTop: '1px',
  },
  label: {
    flex: 1,
  },
}));

const statsRows = [
  {
    label: 'Smalls',
    statKey: 'totalSmalls',
  },
  {
    label: 'Non-Compatibles',
    statKey: 'totalNonCompatibles',
  },
  {
    label: 'Bulk',
    statKey: 'totalBulk',
  },
  {
    label: 'By 10:30',
    statKey: 'totalBy1030',
  },
  {
    label: 'By 12',
    statKey: 'totalBy12',
  },
  {
    label: 'Precise',
    statKey: 'totalPrecise',
  },
  {
    label: 'Afternoon',
    statKey: 'totalAfternoon',
  },
  {
    label: 'Evening',
    statKey: 'totalEvening',
  },
  {
    label: 'Weekend',
    statKey: 'totalWeekend',
  },
];

const StatsCard = ({
  route,
  spot,
  active,
  onDoubleClick,
  onClick,
  onRouteCodeClick,
  onStatusChange,
}) => {
  const styles = useStyles();

  return (
    <BaseCard
      route={route}
      spot={spot}
      active={active}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onRouteCodeClick={onRouteCodeClick}
      onStatusChange={onStatusChange}
      detailedStatus
    >
      <View className={clsx(styles.container, styles.row)}>
        <View className={styles.row}>
          <Text
            className={clsx(styles.text, styles.bold)}
            data-testid="parcels"
          >
            {PARCELS}
          </Text>
          <Text
            className={clsx(styles.text, styles.valueMargin, styles.grey)}
            data-testid="parcels-value"
          >
            {route.totalParcels}
          </Text>
        </View>
        <View className={clsx(styles.row, styles.titleLeftMargin)}>
          <Text
            className={clsx(styles.text, styles.bold)}
            data-testid="collections"
          >
            {COLLECTIONS}
          </Text>
          <Text
            className={clsx(styles.text, styles.valueMargin, styles.grey)}
            data-testid="collections-value"
          >
            {route.totalCollectionStops}
          </Text>
        </View>
      </View>
      <Divider className={styles.divider} />
      <StatsInfoRows
        route={route}
        statsRowsConfig={statsRows}
        labelStyle={styles.label}
        withCollection={false}
      />
    </BaseCard>
  );
};

export default memo(StatsCard);
